import React from 'react';

const ResumoPedido = ({ pedido, onCancelar }) => {
  if (!pedido) return null;
   console.log(pedido);
  return (
    <div className="alert alert-success mt-4">
      <h5>Pedido Realizado</h5>
      <p><strong>Restaurante:</strong> {pedido.restaurante.nomeamigavel}</p>
      <p><strong>Loja:</strong> {pedido.restaurante.loja}</p>
      <p><strong>Turno:</strong> {pedido.turno=== null ? 1 : Number(pedido.turno)+1}º Turno</p>
      <p><strong>Cardápio:</strong> {pedido.opcao}</p>
      <p><strong>Observação:</strong> {pedido.observacao}</p>
      {/*<p><strong>Valor:</strong> R$ {Number(pedido.restaurante.valor).toFixed(2)}</p>*/}
      {pedido.restaurante.status===0 || pedido.status === 0?
      <button className="btn btn-danger" onClick={onCancelar}>Cancelar</button> : null}
    </div>
  );
};

export default ResumoPedido;
